import type { FC, IframeHTMLAttributes } from 'react';

type TProps = IframeHTMLAttributes<HTMLIFrameElement>;
export const ComponentsVideo: FC<TProps> = (props) => {
  return (
    <iframe
      width="100%"
      height="360"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowFullScreen
      {...props}
    />
  );
};
